import { NewPeriod } from '@app/models/period';
import api from '@services/api';

import { PaginationResponse } from '../models/pagination';
import {
  NewSharing,
  ProcessRequest,
  SharingPMORequest,
  SharingPMOResponse,
} from '../models/sharingPMO';

/**
 * <p>
 * API endpoints that cover all resource sharing request related CRUD calls
 */
export const SharingRequestApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // POST
    CreateSharingRequest: builder.mutation<PaginationResponse<NewPeriod>, ProcessRequest>({
      query: (input: ProcessRequest) => ({
        url: encodeURI(`/school/sharing/upload?periodDate=${input.periodDate}`),
        method: 'POST',
        body: input.body,
      }),
      invalidatesTags: ['SharingResponse', 'Periods'],
    }),

    // POST
    CreateSharing: builder.mutation<void, NewSharing>({
      query: (input: NewSharing) => ({
        url: encodeURI(`/school/sharing/create`),
        method: 'POST',
        body: input,
      }),
      invalidatesTags: ['SharingResponse', 'Periods', 'Person'],
    }),
    // GET
    SharingResponse: builder.query<PaginationResponse<SharingPMOResponse>, SharingPMORequest>({
      query: (request) => ({
        url: encodeURI(
          `/school/sharing/searchBy?searchTerm=${request.searchTerm}&periodDate=${request.periodDate}&page=${request.page}&size=${request.size}`,
        ),
        method: 'GET',
      }),
      providesTags: ['SharingResponse'],
    }),
  }),
});

export const {
  useCreateSharingRequestMutation,
  useCreateSharingMutation,
  useSharingResponseQuery,
} = SharingRequestApi;
